module.exports = __webpack_public_path__ + "static/media/abdulrahman.68dc3259.jpg";